import { getPlatformFeatureFlags } from './getFeatureFlags';
export var getSrcUrl = function getSrcUrl(tunnels, extensionResource, defaultUrl) {
  var platformFeatureFlags = getPlatformFeatureFlags();
  var featureFlagsQueryparams = platformFeatureFlags.length > 0 ? "?".concat(new URLSearchParams({
    platformFeatureFlags: platformFeatureFlags.join(',')
  }).toString()) : '';
  var matchTunnel = tunnels.find(function (tunnel) {
    return tunnel.resourceKey === extensionResource;
  });
  if (matchTunnel) {
    return "".concat(matchTunnel.tunnelUrl).concat(featureFlagsQueryparams);
  }
  return "".concat(defaultUrl).concat(featureFlagsQueryparams);
};